import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {CustomerProductHistorySummary} from '../../../../../../../api';
import {ElciaCard} from '../../../../../../components/card/card';
import {Loader} from '../../../../../../components/loader/loader';
import {CustomerProductHistoryItem} from './components/customer-product-history-item/customer-product-history-item';

@Component({
  selector: 'elcia-customer-product-history',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ElciaCard, Loader, CustomerProductHistoryItem],
  templateUrl: './customer-product-history.html',
  styleUrl: './customer-product-history.scss',
  host: {class: 'block min-w-0'},
})
export class CustomerProductHistory {
  history = input.required<CustomerProductHistorySummary[]>();
  isLoading = input.required<boolean>();
  onSelect = output<number>();
}
